import { EditorialSource } from './editorialSource';

// Workflow state of an editorial. Nothing renders publicly until APPROVED.
export enum EditorialStatus {
  DRAFT = 'draft',                 // AI draft generated, awaiting review
  IN_REVIEW = 'in_review',         // an admin has opened it
  CHANGES_REQUESTED = 'changes_requested',
  REJECTED = 'rejected',
  RE_RESEARCH = 're_research',     // admin asked for another research pass
  APPROVED = 'approved',           // live on the plate detail page
}

// A single factual statement. Every claim MUST reference at least one source.
export class EditorialClaim {
  public id: number;
  public text: string;
  public sourceIds: number[];
  // 0..1 — propagated from the backing sources; low values must be surfaced
  // to the reader as uncertainty rather than hidden.
  public confidence: number;
  // Free-text caveat shown when evidence is weak/conflicting.
  public uncertaintyNote?: string;
}

export class EditorialArticle {
  public id: number;
  public registration: string;
  public formattedRegistration: string;
  public status: EditorialStatus;

  public headline: string;
  public summary: string;
  // Body is structured as claims so the UI can show per-claim citations.
  public claims: EditorialClaim[];
  // Markdown body assembled from approved claims (human-editable).
  public bodyMarkdown: string;

  // Overall 0..1 confidence for the whole article.
  public confidence: number;

  public sources: EditorialSource[];

  public createdAt: Date;
  public updatedAt: Date;
  public reviewedBy?: string;
  public reviewerNotes?: string;
  public modelVersion?: string;
}
